import { faPercent } from '@fortawesome/free-solid-svg-icons'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Roles } from '@/auth/azure/Roles'
import { TileRoleRoute } from '@/types'
import { Percentuali } from '@/routes/admin/autodesk/pages/Percentuali'

export const PercentualiRoute = {
  path: 'percentuali',
  text: 'Percentuali',
  element: <Percentuali />,
  mainMenuRoute: false,
  faIcon: faPercent,
  errorElement: <RouterErrorHandler />,
  handle: {
    crumb: () => ({
      label: 'Percentuali',
      icon: faPercent,
    }),
  },
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies TileRoleRoute
